<div>
  @for (table of tables; track table) {
  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          @for (header of table.headers; track header) {
          <th>{{ header }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of table.rows; track row) {
        <tr>
          <td [class.indent]="row.indent">{{ row.properties }}</td>
          <!-- <td>{{ row.method }}</td> -->
          <td>{{ row.unit }}</td>
          <td>{{ row.blend1 }}</td>
          <td>{{ row.j300_0 }}</td>
          <td>{{ row.blend2 }}</td>
          <td>{{ row.j300_1 }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>

<ng-template #methodPanel let-offcanvas>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="method-panel-title">Test Methods</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close test methods panel"
      (click)="offcanvas.dismiss()">
    </button>
  </div>
  <div class="offcanvas-body">
    <table class="method-table">
      <thead>
        <tr>
          <th>Property</th>
          <th>Method</th>
        </tr>
      </thead>
      <tbody>
        @for (row of methodRows; track row.property) {
        <tr>
          <td [class.indent]="row.indent">{{ row.property }}</td>
          <td>{{ row.method }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</ng-template>
